"use client";

import React from "react";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface HouseCatSelectionProps {
  isHouseCat: boolean | null;
  setIsHouseCat: (value: boolean | null) => void;
  error: string;
  isLoading: boolean;
  groupRef: React.RefObject<HTMLDivElement>;
  petName: string; // Added petName prop
  petType: "cat" | "dog"; // Added petType prop for fallback
}

const HouseCatSelection: React.FC<HouseCatSelectionProps> = ({
  isHouseCat,
  setIsHouseCat,
  error,
  isLoading,
  groupRef,
  petName,
  petType,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-2" ref={groupRef}>
      <Label htmlFor="is-housecat">
          {petName ? t("petDetails.isHouseCat", { petName: petName}) : t("petDetails.isHouseCatUndefined") }
      </Label>
      <div className="flex gap-2">
        <Button
          variant={isHouseCat === true ? "default" : "outline"}
          onClick={() => setIsHouseCat(true)}
          className={cn(
            "flex-1",
            isHouseCat === true && "bg-primary text-primary-foreground"
          )}
          disabled={isLoading}
        >
          {t("common.yes")}
        </Button>
        <Button
          variant={isHouseCat === false ? "default" : "outline"}
          onClick={() => setIsHouseCat(false)}
          className={cn(
            "flex-1",
            isHouseCat === false && "bg-primary text-primary-foreground"
          )}
          disabled={isLoading}
        >
          {t("common.no")}
        </Button>
      </div>
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};

export default HouseCatSelection;
